import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import { getUserSession } from "../../../../core/util/core/Session";
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useDispatch } from 'react-redux';
import { useKeysStore } from '../../../../core/store/useKeysStore';

function List() {
    const { keys } = useKeysStore();
    const dispatch = useDispatch();
    const session = getUserSession();

    const profileFilter = chooseProfileFilter();

    const isProjectManager = session.user.application_profile_id == keys?.default_foreign_key?.pdc_profiles?.project_manager

    const pathFrontEnd = '/properties/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllDemonstrativePeriods: config.endpoints.backend + 'demonstrativeperiods/getall',
        endpointDelete: `${config.endpoints.backend}properties/delete`,
        endpoint: config.endpoints.backend + 'properties/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id && !isProjectManager ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            } : {},
            !isProjectManager ? {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            } : {},
            {
                name: 'pdc_demonstrative_period_id',
                type: 'select',
                label: 'Período',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllDemonstrativePeriods,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'year',
                type: 'year',
                selectable: true,
                label: 'Ano',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Patrimônios',
        labelTitleButtonAdd: 'Incluir novo patrimônio',
        fieldsShowOnDelete: ['description'],
        showPrintButtons: true,
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'project',
                label: 'Projeto'
            },
            {
                name: 'type',
                label: 'Tipo'
            },
            {
                name: 'demonstrative_period',
                label: 'Período'
            },
            {
                name: 'reference',
                label: 'Referência',
                width: "15%"
            },
            {
                name: 'description',
                label: 'Descrição'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
